<template>
  <div class="layoutToast">
    <div class="toastText" v-html="text"></div>
  </div>
</template>
<script>
export default {
  name: "LayoutToast",
  props: {
    text: String
  }
};
</script>
<style scoped lang="less">
.layoutToast {
  width: 100vw;
  height: 100vh;
  z-index: 999;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  .toastText {
    max-width: 80%;
    padding: 0.2rem 0.4rem;
    background: rgba(0, 0, 0, 0.8);
    color: #ffffff;
    font-size: 0.3rem;
    border-radius: 0.1rem;
    font-weight: 500;
    margin-top: 40vh;
  }
}
</style>
